(function () {
  'use strict';

  var headers = Array.prototype.slice.call(document.querySelectorAll('[data-cinematic-navigation]'));
  if (!headers.length) return;

  var body = document.body;
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var scrollThreshold = 50;

  headers.forEach(function (header) {
    var toggle = header.querySelector('[data-cinematic-navigation-toggle]');
    var menu = header.querySelector('[data-cinematic-navigation-menu]');
    if (!toggle || !menu) return;

    var openLabel = toggle.getAttribute('data-open-label') || 'Open navigation';
    var closeLabel = toggle.getAttribute('data-close-label') || 'Close navigation';
    var isOpen = false;
    var frameRequested = false;
    var lastMeasuredHeight = 0;
    var wasCompact = null;

    function focusableItems() {
      return Array.prototype.slice.call(
        header.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (item) {
        return item.offsetParent !== null;
      });
    }

    function setOpenState(open, restoreFocus) {
      isOpen = open;
      header.classList.toggle('is-menu-open', open);
      body.classList.toggle('navigation-menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');

      if (restoreFocus) {
        try {
          toggle.focus({ preventScroll: true });
        } catch (error) {
          toggle.focus();
        }
      }
    }

    function shouldCompact() {
      return window.scrollY > scrollThreshold || Boolean(mobileQuery && mobileQuery.matches);
    }

    function setHeaderHeight() {
      var height = Math.ceil(header.getBoundingClientRect().height);
      if (height > 0 && height !== lastMeasuredHeight) {
        lastMeasuredHeight = height;
        document.documentElement.style.setProperty('--cinematic-nav-height', height + 'px');
      }
    }

    function updateCompactState() {
      frameRequested = false;
      var compact = shouldCompact();
      var compactChanged = wasCompact !== compact;
      wasCompact = compact;
      header.classList.toggle('is-compact', compact);

      if (!compact) {
        if (isOpen) setOpenState(false, false);
        menu.setAttribute('aria-hidden', 'false');
      } else if (!isOpen) {
        menu.setAttribute('aria-hidden', 'true');
      }

      // Measure only when compact mode changes or on first pass — not every scroll frame.
      if (compactChanged) setHeaderHeight();
    }

    function requestCompactUpdate(forceMeasure) {
      if (forceMeasure === true) wasCompact = null;
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateCompactState);
    }

    toggle.addEventListener('click', function () {
      setOpenState(!isOpen, false);
    });

    menu.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('a') && isOpen) {
        setOpenState(false, false);
        window.setTimeout(function () {
          if (!header.classList.contains('is-compact')) return;
          try {
            toggle.focus({ preventScroll: true });
          } catch (error) {
            toggle.focus();
          }
        }, 0);
      }
    });

    document.addEventListener('click', function (event) {
      if (isOpen && !header.contains(event.target)) {
        setOpenState(false, true);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        setOpenState(false, true);
        return;
      }

      if (event.key !== 'Tab') return;

      var items = focusableItems();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('scroll', requestCompactUpdate, { passive: true });
    window.addEventListener('resize', function () {
      requestCompactUpdate(true);
    });

    if (mobileQuery) {
      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', function () {
          requestCompactUpdate(true);
        });
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(function () {
          requestCompactUpdate(true);
        });
      }
    }

    if (typeof window.ResizeObserver === 'function') {
      new window.ResizeObserver(function () {
        setHeaderHeight();
      }).observe(header);
    }

    updateCompactState();
  });
})();
